import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';

export var SelfExclusionSelectionTracker = function (_Tracker) {
  _inherits(SelfExclusionSelectionTracker, _Tracker);

  function SelfExclusionSelectionTracker() {
    _classCallCheck(this, SelfExclusionSelectionTracker);

    return _possibleConstructorReturn(this, (SelfExclusionSelectionTracker.__proto__ || _Object$getPrototypeOf(SelfExclusionSelectionTracker)).apply(this, arguments));
  }

  _createClass(SelfExclusionSelectionTracker, [{
    key: 'gamstopClicked',
    value: function gamstopClicked() {
      this.publishPartialEvent('gamstop_click', {
        EventLabel: 'Go To Gamstop'
      });
    }
  }, {
    key: 'selfExcludeFromWhClicked',
    value: function selfExcludeFromWhClicked() {
      this.publishPartialEvent('self_exclusion_WH_click', {
        EventLabel: 'Self Exclude From William Hill'
      });
    }
  }]);

  return SelfExclusionSelectionTracker;
}(Tracker);